export const shareUrl = "https://tabmemo.com";
export const isWeb = Boolean(navigator.userAgent);
